import { bl_fi_report_section_hdr_RowClass } from '../../../dbschema/bl_fi_report_section_hdr.model';
import {BaseContainerModel} from '../../base-container.model';


export class GLSectionContainerModel extends BaseContainerModel {
  bl_fi_report_section_hdr: bl_fi_report_section_hdr_RowClass = new bl_fi_report_section_hdr_RowClass();
}
